export default "__VITE_ASSET__B1$5U2N9__"